// extracted by mini-css-extract-plugin
export default {"dialog":"SimpleDialog_dialog__G544c"};